var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/pro-regular-svg-icons/faBan';
import { ContentPadding } from '../../../components/base';
import { PageWrapper, PageContent } from '../../../components/Page';
import { Button } from '../../../components/Button/button.element';
import { Icon, AvailableIcons } from '../../../components/Icon/Icon.element';
var PermissionDeniedContainer = function (props) { return (_jsxs(PageWrapper, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "Unsupported App" }), _jsx("meta", { name: "description", content: "Unsupported App" })] }), _jsx(PageContent, { children: _jsxs(ContentPadding, __assign({ fullCenter: true, column: true }, { children: [_jsx(FontAwesomeIcon, { style: { margin: 10 }, color: "#858585", size: "2x", icon: faBan }), _jsx("div", { children: "Your App is not supported by the current platform, please contact support" }), _jsx(Button, __assign({ style: { margin: 10 }, type: "smoke", iconLeft: _jsx(Icon, { name: AvailableIcons.ChevronLeft, color: "#fff" }), onClick: props.history.goBack }, { children: "Back" }))] })) })] })); };
export default PermissionDeniedContainer;
